import { styleHookSingleton } from "./hook";
export var styleSingleton = function styleSingleton() {
  var useStyle = styleHookSingleton();

  var Sheet = function Sheet(_a) {
    var styles = _a.styles;
    useStyle(styles);
    return null;
  };

  return Sheet;
};